import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import {
  convertTimestamp,
  convertTimestampsPipe,
} from "../../@core/utils/convertTimestamps.service";

import { replace, remove, clone, find } from "lodash";
import { Project } from "../../models/project.model";

import { ProjectService } from "../../services/project.service";

import { DialogProjectComponent } from "../dialog-project/dialog-project.component";
import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "ngx-view-projects",
  styleUrls: ["./view-projects.component.scss"],
  templateUrl: "./view-projects.component.html",
})
export class ViewProjectsComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = ""; //admin / develop
  @Input() shopId?: string = "";
  projects?: Project[] = [];
  project: Project = new Project();

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  strSearch = "";
  uid = "anonymous";

  companyId = "anonymous";
  @ViewChild("title") title: ElementRef;
  @ViewChild("mobile") mobile: ElementRef;
  isMoreInfo = true;

  constructor(
    private userService: UserService,
    private projectService: ProjectService,
    private router: Router,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.companyId = user.companyId;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
          this.companyId = "anonymous";
        }
        this.getProjects();
      });

    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [
      Validators.minLength(9),
      Validators.maxLength(11),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isMoreInfo = false;
      this.title.nativeElement.focus();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Quick create project
  inputMore() {
    this.isMoreInfo = !this.isMoreInfo;
  }

  inputMobile() {
    if (this.isMoreInfo) {
      this.mobile.nativeElement.focus();
    }
  }

  //load data
  getProjects() {
    this.loading = true;
    this.projectService
      .getProjects(this.shopId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$),
        convertTimestampsPipe()
      )
      .subscribe((data) => {
        this.projects = data;

        console.log("getProjects:", this.projects);

        this.loading = false;
      });
  }

  create() {
    this.project.shopId = this.shopId;
    this.project.title = this.project.title ? this.project.title.trim() : "";

    if (this.project.title.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.projectService
        .create(this.project)
        .then((data) => {
          this.project = new Project();
          this.title.nativeElement.focus();

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onNew() {
    this.dialogService
      .open(DialogProjectComponent, {
        context: {
          header: "Tạo nhà cung cấp",
          mode: "new",
          shopId: this.shopId,
          project: this.project,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.project = new Project();
        }
      });
  }

  onEdit(item: Project) {
    if (item) {
      for (let i = 0; i < this.projects.length; i++) {
        if (this.projects[i].id == item.id) {
          this.projects[i] = item;
          break;
        }
      }
    }
  }

  onDelete(value) {
    remove(this.projects, (e) => {
      return e.id == value;
    });
  }

  //Control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
